import { ButtonIcons, Icons } from '..';
import { icons as moreThanIcons } from '../MoreThan/icons';
import arrowDown from './icons/arrowDown.svg';
import arrowUp from './icons/arrowUp.svg';
import chevron from './icons/chevron.svg';
import clock from './icons/clock.svg';
import download from './icons/download.svg';
import information from './icons/info.svg';
import newTab from './icons/newTab.svg';
import speechBubble from './icons/speech-bubble.svg';
import stickArrowDown from './icons/stickArrowDown.svg';
import stickArrowUp from './icons/stickArrowUp.svg';
import telephone from './icons/telephone.svg';

export const icons: Icons = {
  // have MoreThan icons as default
  ...moreThanIcons,
  'arrow-down': {
    default: arrowDown,
  },
  'arrow-up': {
    default: arrowUp,
  },
  'download-generic': {
    default: download, // Placeholder icon, not used in RSA
  },
  chevron: {
    default: chevron,
  },
  clock: {
    default: clock,
  },
  'download-document': {
    default: download,
  },
  'speech-bubble': {
    default: speechBubble,
  },
  'stick-arrow-down': {
    default: stickArrowDown,
  },
  'stick-arrow-up': {
    default: stickArrowUp,
  },
  telephone: {
    default: telephone,
  },
  'new-tab': {
    default: newTab,
  },
  information: {
    default: information,
  },
};

export const buttonIcons: ButtonIcons = {
  cta: 'chevron',
  add: 'add',
  back: 'chevron',
  download: 'download-document',
  downloadGeneric: 'download-generic',
  edit: 'edit',
  ctaOpenInNewTab: 'new-tab',
  remove: 'remove',
};
